var filterableFilters = {
    init: function() {
        this.setListeners();
    },
    setListeners: function() {
        var form = $('.js-filters-reload');
        var selects = form.find('select');
        selects.on('change', function(e) {
            // For select replaces
            form.find(':input[value=""]').attr('disabled', true);

            // For normal selects
            var unselected = selects.filter(function(index, element) {
                selected = $('option:selected', $(this));
                return $(this).val() == '' || !selected;
            })

            unselected.attr('disabled', true);

            form.trigger('submit');

            // For select replace
            form.find(':input[value=""]').attr('disabled', false);

            var unselected = selects.filter(function(index, element) {
                selected = $('option:selected', $(this));
                return $(this).val() == '' || !selected;
            })

            unselected.attr('disabled', false);
        });
    }
};

filterableFilters.init();
